import React from 'react';

interface HTMLDivInterFace extends React.HTMLAttributes<HTMLDivElement> { }
const Container = React.forwardRef<HTMLDivElement, HTMLDivInterFace>(
    (props, ref) => {
        const { ...rest } = props;
        const divClassname = props.className ? props.className + " margin-container" : "margin-container"

        return <div { ...rest } className={divClassname} ref={ref} ></div>
    }
)

export default Container;